import React from "react";
import "../../css/CRUDModal.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";

const ReportItemModal = ({ show, handleClose, reportData }) => {
  // Dummy example: here we split "5 Items" → [Item 1, Item 2...]
  // Later you can replace this with actual API item details
  const items = reportData?.itemsIncluded
    ? Array.from(
        { length: parseInt(reportData.itemsIncluded) || 0 },
        (_, i) => `Item ${i + 1}`
      )
    : [];

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "760px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              {/* Decorative images */}
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="rightImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />

              {/* Header */}
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h5 className="modal-title main-title font-medium">
                  Items Included
                </h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
              </div>

              {/* Body */}
              <div
                className="scoped-modal modal-body"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "24px",
                }}
              >
                {items?.length > 0 ? (
                  <div
                    className="table-container max-h-[400px] overflow-auto custom-scrollbar"
                    style={{ width: "100%" }}
                  >
                    <div className="table-wrapper">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th className="!bg-[#ffe8d4]">Item Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <tr key={index}>
                              <td>{item}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#888",
                      fontStyle: "italic",
                    }}
                  >
                    No items available.
                  </div>
                )}
              </div>

              {/* Footer */}
              <div
                className="scoped-modal"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "12px",
                  paddingBottom: "0px",
                  gap: "16px",
                  borderTop: "1px solid #dee2e6",
                }}
              >
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportItemModal;
